(function () {
  'use strict';
  // Tüm overlay'ler için merkezi odak yönetimi (focus trap).
  // Mevcut aç/kapa mantığına dokunmaz; açık overlay'i tespit edip
  // odağı içeri taşır, Tab'ı içeride hapseder, Esc ile kapatır,
  // kapanınca odağı açan öğeye geri verir.

  var OVERLAYS = [
    { sel: '#MobileDrawer',       isOpen: function (e) { return e.classList.contains('is-open'); }, close: '[data-drawer-close]' },
    { sel: '#SearchOverlay',      isOpen: function (e) { return e.classList.contains('is-open'); }, close: '[data-search-close]' },
    { sel: '[data-tgpick]',       isOpen: function (e) { return !e.hidden; }, close: '[data-tgpick-close]' },
    { sel: '.qa-overlay',         isOpen: function (e) { return !e.hidden; }, close: '[data-qa-close]' },
    { sel: '[data-taksit-modal]', isOpen: function (e) { return !e.hidden; }, close: '[data-taksit-close]' },
    { sel: '[data-auth-modal]',   isOpen: function (e) { return !e.hidden; }, close: '[data-auth-close]' },
    { sel: '[data-atc]',          isOpen: function (e) { return !e.hidden; }, close: '[data-atc-close]' },
    { sel: '#PetProfile',         isOpen: function (e) { return !e.hidden; }, close: '[data-petp-close]' }
  ];

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusables(container) {
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE))
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
  }

  function focusFirst(el) {
    var f = focusables(el);
    if (!f.length) return;
    var field = el.querySelector('input:not([type="hidden"]), textarea, select');
    if (field && f.indexOf(field) >= 0) field.focus();
    else f[0].focus();
  }

  // Şu an açık overlay'leri DOM sırasına göre döndür (sonuncu = en üstteki)
  function openOverlays() {
    var list = [];
    OVERLAYS.forEach(function (d) {
      var nodes = document.querySelectorAll(d.sel);
      Array.prototype.forEach.call(nodes, function (el) {
        if (d.isOpen(el)) { el.__ftClose = d.close; list.push(el); }
      });
    });
    return list;
  }
  function topOpen() {
    var list = openOverlays();
    return list.length ? list[list.length - 1] : null;
  }

  // Aç/kapa geçişlerini izleyip odağı taşı / geri ver
  var activeEls = [];
  var savedFocus = null;

  function reconcile() {
    var now = openOverlays();
    // Yeni açılanlar
    now.forEach(function (el) {
      if (activeEls.indexOf(el) < 0) {
        if (activeEls.length === 0) savedFocus = document.activeElement;
        activeEls.push(el);
        // Odak zaten içeride değilse içeri taşı
        if (!el.contains(document.activeElement)) {
          // Bazı overlay'ler kendi odaklamasını yapar; kısa gecikme çakışmayı önler
          window.setTimeout(function () { if (el.contains(document.activeElement) === false && openOverlays().indexOf(el) >= 0) focusFirst(el); }, 60);
        }
      }
    });
    // Kapananlar
    activeEls.slice().forEach(function (el) {
      if (now.indexOf(el) < 0) {
        activeEls.splice(activeEls.indexOf(el), 1);
        if (activeEls.length === 0 && savedFocus && typeof savedFocus.focus === 'function') {
          savedFocus.focus();
          savedFocus = null;
        }
      }
    });
  }

  // Gözlemci yalnız overlay'lerin kendisini ilgilendiren değişiklikte reconcile eder (INP, 17 Eki 2026): eskiden sayfadaki her
  // class/hidden/style/metin değişikliğinde 8 querySelectorAll çalışıyordu — ürün sayfasında her boy tıklamasında ~10 ms
  // (CPU 4× yavaş), geri sayımda saniyede bir. Açık/kapalı yalnız class ve hidden'a bakıyor; style gereksizdi.
  var HEPSI = OVERLAYS.map(function (d) { return d.sel; }).join(',');
  function ilgili(muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'attributes') { if (m.target.matches && m.target.matches(HEPSI)) return true; continue; }
      var gruplar = [m.addedNodes, m.removedNodes];
      for (var g = 0; g < 2; g++) {
        for (var k = 0; k < gruplar[g].length; k++) {
          var n = gruplar[g][k];
          if (n.nodeType === 1 && (n.matches(HEPSI) || n.querySelector(HEPSI))) return true;
        }
      }
    }
    return false;
  }
  var mo = new MutationObserver(function (muts) { if (ilgili(muts)) reconcile(); });
  mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden'], childList: true });
  reconcile();

  // Tab hapsi + Esc
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' && e.key !== 'Escape' && e.key !== 'Esc') return;
    var top = topOpen();
    if (!top) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      var btn = top.__ftClose ? top.querySelector(top.__ftClose) : null;
      if (btn) { e.preventDefault(); btn.click(); }
      return;
    }

    // Tab
    var f = focusables(top);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!top.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
